module.exports = __webpack_public_path__ + "static/Unilever-DSEP-ClassroomActivity-Virtual-2.1-WhatsYourFunction_FR-406137bf54b368462051c22219d5e3bd.pdf";